import { APP } from '../../redux/constants/app.constants';

export const DEVCON = `${APP}/DEVCON`;

export const GENERAL = 'general';
export const TRACKING = 'tracking';
export const APP_SETTINGS = 'appSettings';
export const SOUND = `sound`;
export const QUICK_BUTTONS = `quickButtons`;
export const REMOTE_BUTTONS = 'remoteButtons';
export const WIFI = 'wifi';
export const MAN_DOWN = 'manDown';
export const SOS_BUTTON = 'sosButton';
export const RIPCORD = 'ripcord';
export const MENU = 'menu';
export const ALARM_NUMBERS = 'alarmNumbers';
export const WHITE_LIST = 'whitelist';
export const INDOOR = 'indoor';
export const GPS = 'gps';

export const DOWNLOAD_CONFIG = `${DEVCON}/DOWNLOAD_CONFIG`;
export const UPLOAD_CONFIG = `${DEVCON}/UPLOAD_CONFIG`;
export const SET_CONFIG = `${DEVCON}/SET_CONFIG`;
export const SET_SETTING = `${DEVCON}/SET_SETTING`;
export const SET_ADVANCED_MODE = `${DEVCON}/SET_ADVANCED_MODE`;
export const CONFIGS_CHANGED = `${DEVCON}/CONFIGS_CHANGED`;
export const SAVE_CONFIG = `${DEVCON}/SAVE_CONFIG`;
export const DELETE_CONFIG = `${DEVCON}/DELETE_CONFIG`;
export const SAVE_CONFIGS = `${DEVCON}/SAVE_CONFIGS`;
export const GET_CONFIGS = `${DEVCON}/GET_CONFIGS`;
export const LOAD_CONFIG = `${DEVCON}/LOAD_CONFIG`;
export const REBOOT_DEVICE = `${DEVCON}/REBOOT_DEVICE`;
export const WRITE_CONFIG = `${DEVCON}/WRITE_CONFIG`;
export const GET_DEVCON_DATA = `${DEVCON}/GET_DEVCON_DATA`;
export const DEVCON_DATA_CHANGED = `${DEVCON}/DEVCON_DATA_CHANGED`;
export const REBOOT_CHANGED = `${DEVCON}/REBOOT_CHANGED`;
export const DEVCON_DATA_LOADING = `${DEVCON}/DEVCON_DATA_LOADING`;
export const DEVCON_UNMOUNTED = `${DEVCON}/DEVCON_UNMOUNTED`;

// Account-wide customer visibility. Own store key — the DEVCON above is the V3 one.
export const DEVCON_V4 = `${APP}/DEVCON_V4`;

export const GET_VISIBILITY = `${DEVCON_V4}/GET_VISIBILITY`;
export const VISIBILITY_CHANGED = `${DEVCON_V4}/VISIBILITY_CHANGED`;
export const VISIBILITY_FAILED = `${DEVCON_V4}/VISIBILITY_FAILED`;
export const SET_GROUP_VISIBILITY = `${DEVCON_V4}/SET_GROUP_VISIBILITY`;
export const SET_SETTING_VISIBILITY = `${DEVCON_V4}/SET_SETTING_VISIBILITY`;

// Programmed by the device's ARC: read-only in DevCon.
export const ARC_MANAGED_CATEGORIES = [ALARM_NUMBERS];
